import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70a26d7a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a26d7a')) {
      api.createRecord('70a26d7a', component.options)
    } else {
      api.reload('70a26d7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70a26d7a", function () {
      api.rerender('70a26d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/volumeAudit/index.vue"
export default component.exports